// Central place for brand assets and constants
export const IMAGES = {
  logo:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_api-bridge-live/artifacts/cs7vwt44_WhatsApp%20Image%202026-08-25%20at%2018.46.10.jpeg",
  appIcon:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_api-bridge-live/artifacts/1x82h6mf_WhatsApp%20Image%202026-08-25%20at%2018.46.10%20%281%29.jpeg",
  live:
    "https://images.unsplash.com/photo-1632467362004-cf9278e0e781?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  music:
    "https://images.unsplash.com/photo-1543510616-a4025b9c1434?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  social:
    "https://images.unsplash.com/photo-1662858557337-48c9ecf07ee0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const CONTACT_EMAIL = "support@auralive.me";
export const CHILD_SAFETY_EMAIL = "childsafety@auralive.me";
export const APP_NAME = "AuraLive";

// Detect the visitor's mobile platform to surface the matching store first.
export const getPlatform = () => {
  try {
    const ua = (navigator.userAgent || navigator.vendor || "").toLowerCase();
    if (/android/.test(ua)) return "android";
    if (
      /iphone|ipad|ipod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    )
      return "ios";
  } catch (e) {
    /* no-op */
  }
  return "other";
};
export const APP_STORE_ID = "6806855690";
export const APP_STORE_URL = "https://apps.apple.com/app/aura-live/id6806855690";

// Google Play — live listing.
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.auralive.app";

// Build a localized App Store URL from the visitor's browser region, falling
// back to the country-less link (which Apple auto-localizes) if unknown.
export const getAppStoreUrl = () => {
  try {
    const lang = (navigator.language || navigator.userLanguage || "").toLowerCase();
    const region = lang.includes("-") ? lang.split("-")[1] : "";
    if (region && /^[a-z]{2}$/.test(region)) {
      return `https://apps.apple.com/${region}/app/aura-live/id${APP_STORE_ID}`;
    }
  } catch (e) {
    /* no-op */
  }
  return APP_STORE_URL;
};
